<!--  -->
<template>
    <div class='left2_container box_v box_between'>
        <div class="title1  box">社保认证状态</div>
        <div class="content">
            <div v-for="(item,index) in [1,2,3,4]" :key="index" class="items">
                <span class="p1">30%</span>
                <div class="p2">
                    <p>认证成功</p>
                    <p>{{item}}</p>
                </div>
            </div>
            

        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            list:[],
            handelTag:'件'
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.resolveNumberByType).then(res=>{
                let maxNum = res.rows[0].count
                this.list = res.rows.map(item=>{
                    return{
                        typeName:item.typeName,
                        count:maxNum>10000?(item.count/10000).toFixed(2):item.count,
                    }
                })
                this.handelTag = maxNum>10000?'万件':'件'
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.left2_container{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/leftcenter.png');
    background-size: 100% 100%;
    height:100%;
}
.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:20px 0 0 40px
}
.content{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    height: 70%;
    width:100%;
    box-sizing: border-box;
    padding: 0 40px;
    margin-bottom: 20px;
    .items{
        background: url('../../../../assets/images/monitorpy/kk_xx.png');
        background-size: 100% 100%;
        width: 180px;
        height: 70px;
        box-sizing: border-box;
        position: relative;
        text-align: center;
        .p1{
            display: inline-block;
            position: absolute;
            font-size: 18px;
            font-family: FZLanTingHei-B-GBK;
            font-weight: bold;
            font-style: italic;
            color: #B3DDFF;
            line-height: 45px;
            left: 18px;
            top: 15px;
            background: linear-gradient(0deg, #00F6FF 0%, #0290FE 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        .p2{
            position: absolute;
            font-size: 18px;
            font-family: FZLanTingHei-B-GBK;
            font-weight: 400;
            font-style: italic;
            color: #B3DDFF;
            background: linear-gradient(0deg, #00F6FF 0%, #0290FE 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            right: 20px;
            top: 10px;
        }
    }
    
}
</style>